import React from 'react';
import cn from 'classnames';
import addBdayImg from '@app/img/add-birthday.png';
import styles from './BirthdayGraphic.module.scss';

export default function BirthdayGraphic() {
  return (
    <div className={styles.gridCell}>
      <div className={styles.imgContainer}>
        <img src={addBdayImg} className={cn(styles.img, styles.imgBlur)} />
        <img src={addBdayImg} className={styles.img} />
      </div>
    </div>
  );
}
